<template>
    <cic-popup
        :title="item.accountId ? $t('Edit LINE Account') : $t('New LINE Account')"
        :saveable="$store.hasRight('EDIT_ACCESS_TYPE_25')"
        @blur="$emit('blur')"
        @input="validate"
    >
        <div class="item-form">
            <ul style="display: grid">
                <li class="form-item-centred">
                    <div class="form-label-first">{{ $t('Name') }}:</div>
                    <div>
                        <cic-textbox
                            id="channelName"
                            :value="item.channelName"
                            :class="{ highlight: !validation.channelName }"
                            @input="(val) => updateFieldValue('channelName', val)"
                        />
                    </div>
                </li>

                <li class="form-item-centred">
                    <div class="form-label">{{ $t('User ID') }}:</div>
                    <div>
                        <cic-textbox
                            id="userId"
                            :value="item.userId"
                            :class="{ highlight: !validation.userId }"
                            @input="(val) => updateFieldValue('userId', val)"
                        />
                    </div>
                </li>

                <li class="form-item-centred">
                    <div class="form-label">{{ $t('Channel ID') }}:</div>
                    <div>
                        <cic-textbox
                            id="channelId"
                            :value="item.channelId"
                            :class="{ highlight: !validation.channelId }"
                            @input="(val) => updateFieldValue('channelId', val)"
                        />
                    </div>
                </li>

                <li class="form-item-centred">
                    <div class="form-label">{{ $t('Channel Secret') }}:</div>
                    <div>
                        <cic-textbox
                            id="channelSecret"
                            :value="item.channelSecret"
                            :class="{ highlight: !validation.channelSecret }"
                            @input="(val) => updateFieldValue('channelSecret', val)"
                        />
                    </div>
                </li>
            </ul>
        </div>
    </cic-popup>
</template>

<script>
    import CicPopup from '@/components/CicPopup';
    import CicTextbox from '@/components/inputs/CicTextbox';

    export default {
        name: 'EditLineAccount',
        components: {
            CicTextbox,
            CicPopup,
        },
        props: {
            item: {
                type: Object,
                required: true,
            },
        },
        emits: ['blur', 'change', 'input'],
        data() {
            return {
                validation: {
                    userId: true,
                    channelId: true,
                    channelName: true,
                    channelSecret: true,
                },
            };
        },
        methods: {
            updateFieldValue(field, value) {
                this.$emit('change', field, value);
            },
            validate() {
                const validation = {};
                Object.keys(this.validation).forEach((x) => {
                    validation[x] = this.item[x].trim() !== '';
                });
                this.validation = validation;
                if (Object.values(this.validation).some((x) => x === false)) {
                    return;
                }

                this.$emit('input');
            },
        },
    };
</script>
